// The set of review-period reasons Junifer accepts on create. Junifer resolves
// the posted reason to a row in its `AccountReviewReason` reference table by
// exact name match and rejects anything with no match, so this list must mirror
// that table's active (deleteFl='N') names. Junifer trims surrounding
// whitespace on match, so these are stored trimmed. To refresh, query
// `soe-prod-data-gentrack.soe_junifer_source_delta.AccountReviewReason`.
export const reviewPeriodReasons = [
  "Account Investigation",
  "COMC in Progress",
  "COT Deceased",
  "COT General (Moving out/In/Update details etc)",
  "Collections - Breathing Space",
  "Complaint - EHU/CAB",
  "Complaint - Ombudsman",
  "Complaint - Resolutions",
  "Disputed Read (D0300) Process",
  "ECOTN In Progress",
  "Energy Independence",
  "Investigate Dataflow Issue",
  "Ops Billing - Failed Bills",
  "Ops Billing Accuracy",
  "Ops Billing Generation",
  "Ops Industry Corrections",
  "Ops Industry Imbalance",
  "Ops Metering",
  "Ops Metering - Smart Issues",
  "Ops Registrations",
  "Ops Registrations - Cross-metering",
  "Ops Registrations - ET's",
  "Other",
  "Overpaid previous supplier",
  "Payments - IVA",
  "Payments - Payment Promise",
  "Payments - Suppress Direct Debit Review",
  "SOOC Rate Suppression",
  "Supply Loss During Variable Price Change Protection Period",
]
